import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import Select from 'component/utils/Select'
import CompanySelect from 'component/branch/CompanySelect'

const priceBanner = '49'
const commercialManager = '47'
const datasheetNew = '78'

class FeatureCheckEditForm extends Component {
  handleSubmit = (event) => {
    const { values, onSubmit } = this.props
    event.preventDefault()
    onSubmit(values)
  }

  canSubmit = () => {
    const {
      fields: { ...fields },
    } = this.props
    const hasInvalid = Object.keys(fields).some((field) =>
      fields[field].input
        ? fields[field].input.value === '' || fields[field].input.value === 0
        : false
    )
    return !hasInvalid
  }

  clearFields = () => {
    const { fields, values } = this.props

    fields.idBranch.input.value = ''
    fields.cdMenu.input.value = ''
    fields.cdLm.input.value = ''

    fields.idBranch.error = ''
    fields.cdMenu.error = ''
    fields.cdLm.error = ''

    values.idBranch = ''
    values.cdMenu = ''
    values.cdLm = ''
  }

  render() {
    const { translate, fields } = this.props

    return (
      <form className='MenuMissionEditForm' onSubmit={this.handleSubmit}>
        <fieldset>
          <Row>
            <Col xs={12} md={12}>
              <Field
                {...fields.idBranch}
                error={translate(fields.idBranch.error)}
                hint={translate('feature-check.store')}
              >
                <CompanySelect {...fields.idBranch.input} />
              </Field>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Field
                {...fields.cdMenu}
                error={translate(fields.cdMenu.error)}
                hint={translate('feature-check.feature')}
              >
                <Select
                  id='cdMenu'
                  label={translate('feature-check.feature')}
                  {...fields.cdMenu.input}
                >
                  <option value='' />
                  <option value={priceBanner}>
                    {translate('menu.priceBanner')}
                  </option>
                  <option value={datasheetNew}>
                    {translate('menu.datasheetNew')}
                  </option>
                  <option value={commercialManager}>
                    {translate('menu.commercialManag')}
                  </option>
                </Select>
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Field
                {...fields.cdLm}
                error={translate(fields.cdLm.error)}
                hint={translate('feature-check.IdProduct')}
              >
                <Input
                  {...fields.cdLm.input}
                  id='cdLm'
                  className='default-input'
                  placeholder={translate('feature-check.IdProduct')}
                  maxLength={13}
                />
              </Field>
            </Col>
          </Row>
        </fieldset>

        <Row className='margin-top-double margin-bottom'>
          <Col xs={12} md={12}>
            <button
              role='button'
              type='button'
              className='button button-primary button-full'
              onClick={this.handleSubmit}
              disabled={!this.canSubmit()}
            >
              {translate('feature-check.simulate')}
            </button>
          </Col>
        </Row>
      </form>
    )
  }
}

FeatureCheckEditForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
}

const fields = ['idBranch', 'cdMenu', 'cdLm']

export default Form({ fields })(FeatureCheckEditForm)

export { FeatureCheckEditForm }
